import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { Address } from '../../resources';


export const setUserBillingAddress = (address: Address) => restClient.request<null>('/api/v1/billing', {
  method: 'POST',
  data: snakecaseKeys({
    address: address,
  }),
});
